import { AppointmentEntity } from 'backend-entity';

export type CreateAppointmentPayload = Partial<Pick<AppointmentEntity, 'description'>> &
  Pick<AppointmentEntity, 'rentId' | 'customerId' | 'reasons' | 'preferDate'>;
